// eslint-disable-next-line
// @ts-ignore
import { IdcMessagePubSubService, IdcMfeMessageTypes } from "@idc-message/idc-message-pub-sub";
export class IdcMessageScreenReaderService {
    constructor() {
        this.messageReceive = new IdcMessagePubSubService();
    }
    init() {
        this.createScreenReader();
        this.runListeners();
    }
    addMessageToQueue(task) {
        IdcMessageScreenReaderService.promiseQueue = IdcMessageScreenReaderService.promiseQueue
            .then(task)
            .catch(error => {
            // Handle any errors that occur in the promise chain
            console.error('An error occurred in the message queue:', error);
        });
    }
    runListeners() {
        this.messageReceive.runListeners().then((message) => {
            if (message.name === IdcMfeMessageTypes.ScreenReaderData) {
                this.addMessageToQueue(() => this.announce(message.data, this.ariaLiveEl));
            }
        }).catch(() => {
            // Promise rejected - invalid message
        }).finally(() => {
            this.runListeners();
        });
    }
    announce(message, element) {
        const TEXT_VISIBILITY_DURATION_MS = 500;
        return new Promise(resolve => {
            element.textContent = message.text; // setting textContent is HTML-safe (message sanitization)
            setTimeout(() => {
                // Clear the text after the specified duration, so the screen reader knows the message is no longer valid
                element.textContent = '';
                resolve();
            }, TEXT_VISIBILITY_DURATION_MS);
        });
    }
    createScreenReader() {
        this.ariaLiveEl = document.querySelector("[aria-live]");
        if (!this.ariaLiveEl) {
            this.ariaLiveEl = document.createElement("div");
            const id = "announce-" + Date.now();
            this.ariaLiveEl.setAttribute("id", id);
            this.ariaLiveEl.setAttribute("aria-live", "polite");
            // adding class visually hidden to hide the screen reader element
            this.ariaLiveEl.classList.add(...IdcMessageScreenReaderService.ARIA_LIVE_CLASSES);
            document.body.appendChild(this.ariaLiveEl);
        }
    }
}
IdcMessageScreenReaderService.ARIA_LIVE_CLASSES = ['show-for-sr', 'aria-live-container'];
IdcMessageScreenReaderService.promiseQueue = Promise.resolve();
